import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  getUserDetails,
  getAllCrewUser,
  getProjectUserDetails,
  addCrewUser,
  getCrewEquipmentList,
  getAllEquipmentList,
  deleteCrewUser,
  deleteCrewEquipment,
  editCrewUser,
  // setDefaultCostCode,
  getAllCrews,
  updateCrewDetails,
} from "../API";
import Loader from "./Loader";
import deleteIcon from "../assets/images/delete2.png";
import disabledDeleteIcon from "../assets/images/disabledDelete2.png";
import AddProjectCrewUser from "../components/AddProjectCrewUser";
import { toast } from "react-toastify";
import ArrowLeft from "../assets/images/left-arrow.png";
// import NotAllowed from "../assets/images/not-allowed.png";
import NotAllowed from "../assets/images/no-stopping.svg";
// import Enabled from "../assets/images/enabled.png";
import Enabled from "../assets/images/Group 1.svg";
import AddCrewEquipment from "../components/AddCrewEquipment";
import StepUpForemanListModal from "../components/StepUpForemanListModal";
import "../assets/styles/crew-management.scss";

const CrewManagement = () => {
  const { crewId } = useParams();
  const [CREWID, setCREWID] = useState();
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [filteredUserOptions, setFilteredUserOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [crewMemberList, setCrewMemberList] = useState([]);
  const [allCrewEquipment, setAllCrewEquipment] = useState([]);
  const [allEquipments, setAllEquipments] = useState([]);
  const [dropDownLoader, setDropDownLoader] = useState(false);
  const [defaultUserRoles, setDefaultUserRoles] = useState({
    foreman: {
      label: "",
      value: "",
    },
    generalForeman: {
      label: "",
      value: "",
    },
    opsManager: {
      label: "",
      value: "",
    },
  });
  const [stepUpForemen, setStepUpForemen] = useState();
  const [stepUpForemenId, setStepUpForemenId] = useState(null);
  const [crewDetails, setCrewDetails] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);

  const user_id = localStorage.getItem("user_id");
  const role = localStorage.getItem("role_name");
  const isActionAccessible = !user_id && role === "Admin";

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (employeeOptions?.length) {
      const defaultStepUpForeman = employeeOptions.find(
        (option) => option.value === stepUpForemen?.user_id
      );
      setStepUpForemen(defaultStepUpForeman);
    }
  }, [employeeOptions, crewMemberList]);

  const fetchData = async () => {
    try {
      const [
        employees,
        userOptions,
        empList,
        crewEquipments,
        allEquipments,
        crewDetails,
      ] = await Promise.all([
        getUserDetails(),
        getAllCrewUser(crewId),
        getProjectUserDetails(),
        getCrewEquipmentList(crewId),
        getAllEquipmentList(),
        getAllCrews(crewId),
      ]);

      if (crewDetails?.status === 200) {
        fetchCrewDetails();
      }

      if (allEquipments?.status === 200) {
        setAllEquipments(allEquipments?.data);
      }

      if (crewEquipments?.status === 200) {
        setAllCrewEquipment(crewEquipments?.data);
      }
      
      if (userOptions) {
        const allStepUpForemen = userOptions?.data?.find(
          (user) => user?.crew_role_id === 5
        );
        setStepUpForemen(allStepUpForemen);
        setStepUpForemenId(allStepUpForemen?.id);
      }
  
      if (employees && userOptions) {
        const filteredEmployees = employees?.data
          ?.filter((employee) => {
            const roleUsers = userOptions?.data?.find((user) => {
              return (
                user?.user_id === employee?.id && user?.type === "permanent"
              );
            });
            return employee?.id !== roleUsers?.user_id;
          })
          .map((ele) => {
            const roleUsers = userOptions?.data?.find((user) => {
              return user?.user_id === ele?.id;
            });
            return {
              ...ele,
              type: roleUsers?.type || "NA",
              crew_user_id: roleUsers?.id || "NA",
            };
          });
        setFilteredUserOptions(filteredEmployees);
      }

      if (employees && userOptions) {
        setLoading(false);

        const defaultForeman = userOptions?.data?.find(
          (user) => user?.crew_role_id === 1
        );
        const defaultGeneralForeman = userOptions?.data?.find(
          (user) => user?.crew_role_id === 2
        );
        const defaultOpsManager = userOptions?.data?.find(
          (user) => user?.crew_role_id === 3
        );

        setDefaultUserRoles({
          foreman: {
            label: defaultForeman
              ? `${defaultForeman?.user?.name}  ${
                  defaultForeman?.user?.employee_id !== null
                    ? `(${defaultForeman?.user?.employee_id})`
                    : ""
                }`
              : "",
            value: defaultForeman?.user?.id,
          },
          generalForeman: {
            label: defaultGeneralForeman
              ? `${defaultGeneralForeman?.user?.name}  ${
                  defaultGeneralForeman?.user?.employee_id !== null
                    ? `(${defaultGeneralForeman?.user?.employee_id})`
                    : ""
                }`
              : "",
            value: defaultGeneralForeman?.user?.id,
          },
          opsManager: {
            label: defaultOpsManager
              ? `${defaultOpsManager?.user?.name}  ${
                  defaultOpsManager?.user?.employee_id !== null
                    ? `(${defaultOpsManager?.user?.employee_id})`
                    : ""
                }`
              : "",
            value: defaultOpsManager?.user?.id,
          },
        });

        const filteredCrewMembersList = userOptions?.data?.filter(
          (ele) => ele.crew_role_id === 4 && ele.type === "permanent"
        );
        const filterOutCrewRoles = userOptions?.data?.filter(
          (ele) => ele?.crew_role_id < 4
        );
        setCrewMemberList(filteredCrewMembersList);
        let employeeArr = [];
        await empList.data.forEach((user) => {

          if (user.role.name === "member") {
            const crewMember = filteredCrewMembersList?.find(
              (ele) => ele?.user?.id === user?.id
            );
            const filterOutCrewUserRoles = filterOutCrewRoles?.find(
              (ele) => ele?.user?.id === user?.id
            );
            if (!filterOutCrewUserRoles) {
              const label = `${user.name} ${
                user?.employee_id !== null ? `(${user?.employee_id})` : ""
              }`;
              employeeArr.push({
                value: user.id,
                employee_id: user?.employee_id,
                crew_user_id: crewMember ? crewMember?.id : null,
                label,
              });
            }
          }
        });
        setEmployeeOptions(employeeArr);
        // setFilteredEmployeeOptions(employeeArr);

      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const onDeleteCrewUser = async (item) => {
    if (isActionAccessible) {
      await deleteCrewUser(item?.id)
        .then((res) => {
          if (res?.status === 204) {
            onAddNewMember();
            toast.success("Entry Deleted Successfully");
          }
        })
        .catch(() => toast.error("Unable to delete crew user"));
    }
  };

  const onDeleteCrewEquipment = async (item) => {
    if (isActionAccessible) {
      await deleteCrewEquipment(item?.id)
        .then((res) => {
          if (res?.status === 204) {
            onAddNewEquipment();
            toast.success("Entry Deleted Successfully");
          }
        })
        .catch(() => toast.error("Unable to delete crew user"));
    }
  };

  const onAddNewMember = async () => {
    const userOptions = await getAllCrewUser(crewId);
    const filteredCrewMemberList = userOptions?.data?.filter(
      (ele) => ele.crew_role_id === 4 && ele?.type === "permanent"
    );
    setCrewMemberList(filteredCrewMemberList);

    const stepUpForemanMembers = userOptions?.data?.find(
      (ele) => ele.crew_role_id === 5 && ele?.type === "permanent"
    );
    setStepUpForemen(stepUpForemanMembers);
    setStepUpForemenId(stepUpForemanMembers?.id);
    const allEmployee = await getUserDetails();
    const filteredEmployees = allEmployee?.data
      ?.filter((employee) => {
        const roleUsers = userOptions?.data?.find((user) => {
          return user?.user_id === employee?.id && user?.type === "permanent";
        });
        return employee?.id !== roleUsers?.user_id;
      })
      .map((ele) => {
        const roleUsers = userOptions?.data?.find((user) => {
          return user?.user_id === ele?.id;
        });
        return {
          ...ele,
          type: roleUsers?.type || "NA",
          crew_user_id: roleUsers?.id || "NA",
        };
      });
    setFilteredUserOptions(filteredEmployees);
  };

  const onAddNewEquipment = async () => {
    const equipmentOptions = await getCrewEquipmentList(crewId);
    setAllCrewEquipment(equipmentOptions?.data);
  };

  const crewTableHeadings = ["Employee ID", "Name", "Action"];
  const crewEquipmentHeadings = [
    "Equipment Id",
    "Equipment",
    // "Default Cost Code",
    "Action",
  ];

  const [selectedUser, setSelectedUser] = useState({});

  const addNewCrewMember = async (payload) => {
    await addCrewUser(payload).then((res) => {
      if (res?.status === 200) {
        toast.success("Changed Successfully");
      }
    });
  };
  const navigate = useNavigate();
  // const defaultCostCodeOnChange = async (event, item) => {
  //   const payload = {
  //     id: item?.id,
  //     data: {
  //       default_crew_project_cost_code: event?.value?.id,
  //     },
  //   };
  //   await setDefaultCostCode(payload?.id, payload?.data).then((res) => {
  //     toast.success("Default cost code updated");
  //   });
  // };

  const addNewCrewMemberPromise = async (data) => {
    if (data && data?.value === stepUpForemen?.value) {
      toast.warning("Already a Step-up foreman");
      return;
    }
    // No Step-up foreman is selected
    if (!stepUpForemen?.value && !stepUpForemenId) {
      const isUserACrewMember = crewMemberList?.find(
        (ele) => ele?.user?.id === data?.value
      );
      if (isUserACrewMember) {
        setDropDownLoader(true);
        setStepUpForemen(data);
        const payload = {
          id: data?.crew_user_id,
          data: {
            crew_role_id: 5,
          },
        };
        await editCrewUser(payload)
          .then((res) => {
            onAddNewMember();
            toast.success("Added Successfully");
          })
          .catch((error) => {
            setStepUpForemen(null);
            toast.error("Something went wrong");
          })
          .finally(setDropDownLoader(false));
      } else {
        try {
          setDropDownLoader(true);
          setStepUpForemen(data);
          const crewUserPayload = {
            crew_id: crewId,
            user_id: data?.value,
            crew_role_id: 5,
          };
          const addResponse = await addCrewUser(crewUserPayload);
          if (addResponse?.status === 200) {
            onAddNewMember();
            toast.success("Added Successfully");
          }
        } catch (error) {
          setStepUpForemen(null);
          toast.error("Something went wrong");
        } finally {
          setDropDownLoader(false);
        }
      }
    }
    // Step-up foreman is selected
    else if (stepUpForemen?.value && stepUpForemenId) {
      const isUserACrewMember = crewMemberList?.find(
        (ele) => ele?.user?.id === data?.value
      );

      const payload = {
        id: stepUpForemenId,
        data: {
          crew_role_id: 4,
        },
      };
      await editCrewUser(payload)
        .then(async (res) => {
          if (isUserACrewMember && data) {
            setDropDownLoader(true);
            setStepUpForemen(data);
            const payload = {
              id: data?.crew_user_id,
              data: {
                crew_role_id: 5,
              },
            };
            await editCrewUser(payload)
              .then((res) => {
                onAddNewMember();
                toast.success("Added Successfully");
              })
              .catch((error) => {
                setStepUpForemen(null);
                toast.error("Something went wrong");
              })
              .finally(setDropDownLoader(false));
          } else if (data) {
            try {
              setDropDownLoader(true);
              setStepUpForemen(data);
              const crewUserPayload = {
                crew_id: crewId,
                user_id: data?.value,
                crew_role_id: 5,
              };
              const addResponse = await addCrewUser(crewUserPayload);
              if (addResponse?.status === 200) {
                onAddNewMember();
                toast.success("Added Successfully");
              }
            } catch (error) {
              setStepUpForemen(null);
              toast.error("Something went wrong");
            } finally {
              setDropDownLoader(false);
            }
          } else {
            setStepUpForemen(data);
            onAddNewMember();
          }
        })
        .catch((error) => {
          setStepUpForemen(null);
          toast.error("Something went wrong");
        });
    }
  };

  const fetchCrewDetails = async () => {
    const crewDetails = await getAllCrews(crewId);
    setCREWID(crewDetails?.data[0]?.virtual_id);
    setCrewDetails(crewDetails?.data[0]);
  };

  const onClickDeactivate = async () => {
    setButtonLoading(true);
    const payload = {
      is_active: !crewDetails?.is_active,
    };

    await updateCrewDetails(payload, crewId)
      .then((res) => {
        setButtonLoading(false);
        res?.data?.is_active
          ? toast.success("Crew activated successfully")
          : toast.success("Crew deactivated successfully");
        fetchCrewDetails();
      })
      .catch((err) => setButtonLoading(false));
  };

  const crewInfoFields = [
    {
      label: "Crew Id",
      value: CREWID,
    },
    {
      label: "Foreman",
      value: defaultUserRoles?.foreman?.label,
    },
    {
      label: "General Foreman",
      value: defaultUserRoles?.generalForeman?.label,
    },
    {
      label: "Ops Manager",
      value: defaultUserRoles?.opsManager?.label,
    },
  ];

  return (
    <div className="crew-mgmt project-details-page crew-management-page">
      <div className="project-details-toolbar">
        <button
          className="btn btn-primary back-btn project-details-back-btn"
          onClick={() => navigate(-1)}
          type="button"
        >
          <img src={ArrowLeft} alt="Back" />
        </button>
        <h1 className="title project-details-title">Crew Management</h1>
        <div className="project-details-toolbar__actions">
          {isActionAccessible && !loading && crewDetails && (
            <button
              disabled={buttonLoading}
              className="btn primary-btn px-2 space-between-flex-container status-btn"
              onClick={() => onClickDeactivate()}
              type="button"
            >
              {crewDetails?.is_active ? (
                <>
                  <img className="me-1" src={NotAllowed} alt="" /> Deactivate
                </>
              ) : (
                <>
                  <img className="me-1" src={Enabled} alt="" /> Activate
                </>
              )}
            </button>
          )}
        </div>
      </div>
      {!loading ? (
        <>
          <div className="crew-mgmt-card project-details-summary-card">
            <div className="project-details-summary-grid">
              {crewInfoFields.map((field) => (
                <div className="project-details-summary-column" key={field.label}>
                  <label className="project-details-field__label">
                    {field.label}
                  </label>
                  <div className="project-details-field__control">
                    <input
                      value={field.value || "NA"}
                      disabled
                      name={field.label}
                      type="text"
                      className="form-control project-details-field__input"
                    />
                  </div>
                </div>
              ))}
              <div className="project-details-summary-column">
                <label className="project-details-field__label">
                  Step-up Foreman
                </label>
                <div className="project-details-field__control">
                  <Select
                    classNamePrefix="crew-management-select"
                    className="crew-management-step-up-select"
                    value={stepUpForemen}
                    onChange={(e) => addNewCrewMemberPromise(e)}
                    aria-label="Step-up Foreman"
                    options={employeeOptions}
                    isLoading={dropDownLoader}
                    isClearable={true}
                    isDisabled={dropDownLoader}
                  />
                </div>
              </div>
              <div className="project-details-summary-column">
                <label className="project-details-field__label">Status</label>
                <div className="project-details-field__control crew-management-status-control">
                  <span
                    className={`status-pill ${
                      crewDetails?.is_active
                        ? "status-pill-active"
                        : "status-pill-inactive"
                    }`}
                  >
                    {crewDetails?.is_active ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="crew-management-tables">
            <section>
              <div className="crew-management-section-head">
                <h4 className="title project-details-section-title">
                  Crew Members
                </h4>
                {isActionAccessible && (
                  <AddProjectCrewUser
                    state={crewId}
                    userOptions={filteredUserOptions}
                    onAddNewMember={onAddNewMember}
                  />
                )}
              </div>
              <div className="table-responsive project-details-table-wrap">
                <table className="table table-bordered project-details-table crew-management-table">
                  <thead>
                    <tr>
                      {crewTableHeadings?.map((item, key) => (
                        <th scope="col" key={key}>
                          {item}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {crewMemberList && crewMemberList.length > 0 ? (
                      crewMemberList.map((item, key) => {
                        const user = employeeOptions.find(
                          (user) => user?.value === item?.user_id
                        );
                        return (
                          <tr
                            className={
                              selectedUser.id === item?.id ? "activeRow" : ""
                            }
                            onClick={() => setSelectedUser(item)}
                            key={key}
                          >
                            <td>
                              {user?.employee_id ? user?.employee_id : "NA"}
                            </td>
                            <td>{item?.user?.name}</td>
                            <td className="details-td crew-management-action-cell">
                              <div className="icons">
                                <img
                                  src={
                                    isActionAccessible
                                      ? deleteIcon
                                      : disabledDeleteIcon
                                  }
                                  alt=""
                                  className={
                                    isActionAccessible
                                      ? "img-fluid crew-management-delete-icon"
                                      : "crew-management-delete-icon-disabled"
                                  }
                                  onClick={() => onDeleteCrewUser(item)}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      !loading && (
                        <tr>
                          <td
                            colSpan={crewTableHeadings.length}
                            className="crew-management-empty"
                          >
                            No data found
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </section>
            <section>
              <div className="crew-management-section-head">
                <h4 className="title project-details-section-title">
                  Crew Equipment
                </h4>
                {isActionAccessible && (
                  <AddCrewEquipment
                    state={crewId}
                    allEquipments={allEquipments}
                    allCrewEquipments={allCrewEquipment}
                    onAddNewEquipment={onAddNewEquipment}
                  />
                )}
              </div>
              <div className="table-responsive project-details-table-wrap">
                <table className="table table-bordered project-details-table crew-management-table">
                  <thead>
                    <tr>
                      {crewEquipmentHeadings?.map((item, key) => (
                        <th scope="col" key={key}>
                          {item}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allCrewEquipment && allCrewEquipment.length > 0 ? (
                      allCrewEquipment.map((item, key) => {
                        return (
                          item?.type === "permanent" && (
                            <tr
                              onClick={() => setSelectedUser(item)}
                              key={key}
                            >
                              <td>{item?.equipment?.acumatica_id}</td>
                              <td>{item?.equipment?.name}</td>
                              <td className="details-td crew-management-action-cell">
                                <div className="icons">
                                  <img
                                    src={
                                      isActionAccessible
                                        ? deleteIcon
                                        : disabledDeleteIcon
                                    }
                                    alt=""
                                    className={
                                      isActionAccessible
                                        ? "img-fluid crew-management-delete-icon"
                                        : "crew-management-delete-icon-disabled"
                                    }
                                    onClick={() =>
                                      onDeleteCrewEquipment(item)
                                    }
                                  />
                                </div>
                              </td>
                            </tr>
                          )
                        );
                      })
                    ) : (
                      !loading && (
                        <tr>
                          <td
                            colSpan={crewEquipmentHeadings.length}
                            className="crew-management-empty"
                          >
                            No data found
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <StepUpForemanListModal
            state={crewId}
            userOptions={filteredUserOptions}
            onAddNewMember={onAddNewMember}
            stepUpForemen={stepUpForemen}
          />
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default CrewManagement;
